import * as types from './types';

/**
 * ---------------------------------------------------
 *  LINHAS DE CUIDADO ATIVAS NA INSTITUIÇÃO
 * ---------------------------------------------------
 */
export function listarLcsRequest(payload) {
  return {
    type: types.LISTAR_LCS_REQUEST,
    payload,
  };
}

export function listarLcsSuccess(payload) {
  return {
    type: types.LISTAR_LCS_SUCCESS,
    payload,
  };
}

export function listarLcsFailure() {
  return {
    type: types.LISTAR_LCS_FAILURE,
  };
}

/**
 * ---------------------------------------------------
 *  CANCER DE MAMA
 * ---------------------------------------------------
 */
export function cancerDeMamaRequest(payload) {
  return {
    type: types.LC_CANCER_MAMA_REQUEST,
    payload,
  };
}

export function cancerDeMamaSuccess(payload) {
  return {
    type: types.LC_CANCER_MAMA_SUCCESS,
    payload,
  };
}

export function cancerDeMamaFailure(payload) {
  return {
    type: types.LC_CANCER_MAMA_FAILURE,
    payload,
  };
}

// GET MAMA

export function cancerDeMamaGetRequest(payload) {
  return {
    type: types.GET_CANCER_MAMA_REQUEST,
    payload,
  };
}

export function cancerDeMamaGetSuccess(payload) {
  return {
    type: types.GET_CANCER_MAMA_SUCCESS,
    payload,
  };
}

export function cancerDeMamaGetFailure(payload) {
  return {
    type: types.GET_CANCER_MAMA_FAILURE,
    payload,
  };
}

// UPDATE MAMA

export function cancerDeMamaUpdateRequest(payload) {
  return {
    type: types.LC_CANCER_MAMA_UPDATE_REQUEST,
    payload,
  };
}

export function cancerDeMamaUpdateSuccess(payload) {
  return {
    type: types.LC_CANCER_MAMA_UPDATE_SUCCESS,
    payload,
  };
}

export function cancerDeMamaUpdateFailure(payload) {
  return {
    type: types.LC_CANCER_MAMA_UPDATE_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 *  QUADRIL
 * ---------------------------------------------------
 */
export function quadrilRequest(payload) {
  return {
    type: types.LC_QUADRIL_REQUEST,
    payload,
  };
}

export function quadrilSuccess(payload) {
  return {
    type: types.LC_QUADRIL_SUCCESS,
    payload,
  };
}

export function quadrilFailure(payload) {
  return {
    type: types.LC_QUADRIL_FAILURE,
    payload,
  };
}

// GET QUADRIL

export function quadrilGetRequest(payload) {
  return {
    type: types.GET_QUADRIL_REQUEST,
    payload,
  };
}

export function quadrilGetSuccess(payload) {
  return {
    type: types.GET_QUADRIL_SUCCESS,
    payload,
  };
}

export function quadrilGetFailure(payload) {
  return {
    type: types.GET_QUADRIL_FAILURE,
    payload,
  };
}

// UPDATE QUADRIL

export function quadrilUpdateRequest(payload) {
  return {
    type: types.LC_QUADRIL_UPDATE_REQUEST,
    payload,
  };
}

export function quadrilUpdateSuccess(payload) {
  return {
    type: types.LC_QUADRIL_UPDATE_SUCCESS,
    payload,
  };
}

export function quadrilUpdateFailure(payload) {
  return {
    type: types.LC_QUADRIL_UPDATE_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 *  ACIDENTE VASCULAR CEREBRAL (AVC)
 * ---------------------------------------------------
 */
export function avcRequest(payload) {
  return {
    type: types.LC_AVC_REQUEST,
    payload,
  };
}

export function avcSuccess(payload) {
  return {
    type: types.LC_AVC_SUCCESS,
    payload,
  };
}

export function avcFailure(payload) {
  return {
    type: types.LC_AVC_FAILURE,
    payload,
  };
}

// GET AVC

export function avcGetRequest(payload) {
  return {
    type: types.GET_AVC_REQUEST,
    payload,
  };
}

export function avcGetSuccess(payload) {
  return {
    type: types.GET_AVC_SUCCESS,
    payload,
  };
}

export function avcGetFailure(payload) {
  return {
    type: types.GET_AVC_FAILURE,
    payload,
  };
}

// UPDATE AVC

export function avcUpdateRequest(payload) {
  return {
    type: types.LC_AVC_UPDATE_REQUEST,
    payload,
  };
}

export function avcUpdateSuccess(payload) {
  return {
    type: types.LC_AVC_UPDATE_SUCCESS,
    payload,
  };
}

export function avcUpdateFailure(payload) {
  return {
    type: types.LC_AVC_UPDATE_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 *  CANCER DE PROSTATA
 * ---------------------------------------------------
 */
export function cancerDeProstataRequest(payload) {
  return {
    type: types.LC_CANCER_PROSTATA_REQUEST,
    payload,
  };
}

export function cancerDeProstataSuccess(payload) {
  return {
    type: types.LC_CANCER_PROSTATA_SUCCESS,
    payload,
  };
}

export function cancerDeProstataFailure(payload) {
  return {
    type: types.LC_CANCER_PROSTATA_FAILURE,
    payload,
  };
}

// GET PROSTATA

export function cancerDeProstataGetRequest(payload) {
  return {
    type: types.GET_CANCER_PROSTATA_REQUEST,
    payload,
  };
}

export function cancerDeProstataGetSuccess(payload) {
  return {
    type: types.GET_CANCER_PROSTATA_SUCCESS,
    payload,
  };
}

export function cancerDeProstataGetFailure(payload) {
  return {
    type: types.GET_CANCER_PROSTATA_FAILURE,
    payload,
  };
}

// UPDATE PROSTATA

export function cancerDeProstataUpdateRequest(payload) {
  return {
    type: types.LC_CANCER_PROSTATA_UPDATE_REQUEST,
    payload,
  };
}

export function cancerDeProstataUpdateSuccess(payload) {
  return {
    type: types.LC_CANCER_PROSTATA_UPDATE_SUCCESS,
    payload,
  };
}

export function cancerDeProstataUpdateFailure(payload) {
  return {
    type: types.LC_CANCER_PROSTATA_UPDATE_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 *  SEPSE
 * ---------------------------------------------------
 */

export function sepseRequest(payload) {
  return {
    type: types.LC_SEPSE_REQUEST,
    payload,
  };
}

export function sepseSuccess(payload) {
  return {
    type: types.LC_SEPSE_SUCCESS,
    payload,
  };
}

export function sepseFailure(payload) {
  return {
    type: types.LC_SEPSE_FAILURE,
    payload,
  };
}

// GET SEPSE

export function sepseGetRequest(payload) {
  return {
    type: types.GET_SEPSE_REQUEST,
    payload,
  };
}

export function sepseGetSuccess(payload) {
  return {
    type: types.GET_SEPSE_SUCCESS,
    payload,
  };
}

export function sepseGetFailure(payload) {
  return {
    type: types.GET_SEPSE_FAILURE,
    payload,
  };
}

// UPDATE SEPSE

export function sepseUpdateRequest(payload) {
  return {
    type: types.LC_SEPSE_UPDATE_REQUEST,
    payload,
  };
}

export function sepseUpdateSuccess(payload) {
  return {
    type: types.LC_SEPSE_UPDATE_SUCCESS,
    payload,
  };
}

export function sepseUpdateFailure(payload) {
  return {
    type: types.LC_SEPSE_UPDATE_FAILURE,
    payload,
  };
}
/**
 * ---------------------------------------------------
 *  SCA
 * ---------------------------------------------------
 */

export function scaRequest(payload) {
  return {
    type: types.LC_SCA_REQUEST,
    payload,
  };
}

export function scaSuccess(payload) {
  return {
    type: types.LC_SCA_SUCCESS,
    payload,
  };
}

export function scaFailure(payload) {
  return {
    type: types.LC_SCA_FAILURE,
    payload,
  };
}

// GET SCA

export function scaGetRequest(payload) {
  return {
    type: types.GET_SCA_REQUEST,
    payload,
  };
}

export function scaGetSuccess(payload) {
  return {
    type: types.GET_SCA_SUCCESS,
    payload,
  };
}

export function scaGetFailure(payload) {
  return {
    type: types.GET_SCA_FAILURE,
    payload,
  };
}

// UPDATE SCA

export function scaUpdateRequest(payload) {
  return {
    type: types.LC_SCA_UPDATE_REQUEST,
    payload,
  };
}

export function scaUpdateSuccess(payload) {
  return {
    type: types.LC_SCA_UPDATE_SUCCESS,
    payload,
  };
}

export function scaUpdateFailure(payload) {
  return {
    type: types.LC_SCA_UPDATE_FAILURE,
    payload,
  };
}

// CALCULO DE GRACE

export function graceRequest(payload) {
  return {
    type: types.GRACE_REQUEST,
    payload,
  };
}

export function graceSuccess(payload) {
  return {
    type: types.GRACE_SUCCESS,
    payload,
  };
}

export function graceFailure(payload) {
  return {
    type: types.GRACE_FAILURE,
    payload,
  };
}
